module.exports = __webpack_public_path__ + "static/media/amyraa2.4075d555.png";